module.exports = __webpack_public_path__ + "img/Star.1a886b7a.svg";